import React, { forwardRef, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import UploadMultiFolders from "./UploadMultiFolders";
import UploadMultiFiles from "./UploadMultiFiles";
import Swal from "sweetalert2";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";

const allowedExtensions = [
  ".csv", ".txt", ".rtf", ".zip", ".xpt",
  ".png", ".jpg", ".jpeg", ".xls", ".xlsx",
  ".pdf", ".doc", ".docx", ".ppt", ".pptx",
];
const UploadMultiFilesFolders = forwardRef(
  ({ Show, Hide, Title, sourceKey, getTotalS3Folders }, ref) => {
    const [buttonLoader, setButtonLoader] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [type, setType] = useState("");

    const handleFileChange = (e) => {
      const files = Array.from(e.target.files);
      setSelectedFiles(files);
    };

    const uploadFilesToS3 = async (e) => {
      if (!selectedFiles || selectedFiles.length === 0) {
        Swal.fire("No files selected", "Please choose at least one file.", "warning");
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Upload File?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#103C5E",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Upload it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setButtonLoader(true);
          const formData = new FormData();
          selectedFiles.forEach((file) => formData.append("files", file));
          formData.append("path", sourceKey || "/");
          const result = await s3FileManagerServices.uploadFilesToS3(formData);
          if (result?.statusCode === 200) {
            setSelectedFiles([]);
            getTotalS3Folders()
            Hide()
          }
          setButtonLoader(false);
        }
      });
    };

    const handleFolderChange = (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;
      const folderName = files[0].webkitRelativePath.split("/")[0];
      if (selectedFiles.some(f => f.name === folderName)) {
        Swal.fire("Folder already added", "", "warning");
        return;
      }
      setSelectedFiles(prev => [...prev, { name: folderName, files }]);
    };

    const uploadMultipleLocalS3Folder = async () => {
      if (!selectedFiles || selectedFiles.length === 0) {
        Swal.fire("No folder selected", "Please choose at least one folder.", "warning");
        return;
      }

      const resultConfirm = await Swal.fire({
        title: "Are you sure?",
        text: "You want to upload the selected folder(s)?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#103C5E",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Upload!",
      });

      if (!resultConfirm.isConfirmed) return;

      try {
        setButtonLoader(true);
        const formData = new FormData();
        formData.append("path", sourceKey || "Uncategorized/");

        selectedFiles.forEach((file) => {
          formData.append("files", file, file.webkitRelativePath);
        });

        const result = await s3FileManagerServices.uploadMultipleLocalS3Folder(formData);

        if (result?.statusCode === 200) {
          Swal.fire("Success!", "Folder uploaded successfully.", "success");
          setSelectedFiles([]);
          Hide();
        } else {
          Swal.fire("Error!", "Failed to upload folder.", "error");
        }
      } catch (error) {
        console.error("Upload Error:", error);
        Swal.fire("Error!", "Something went wrong while uploading.", "error");
      } finally {
        setButtonLoader(false);
      }
    };
    return (
      <Modal show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1">
                Select Type{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                onChange={(e) => setType(e.target.value)}
                style={{ fontSize: 12 }}
                value={type}
                className="br3"
              >
                <option value="">
                  Select Upload Type
                </option>
                <option value="folders">
                  Folders
                </option>
                <option value="files">
                  Files
                </option>
              </Form.Select>
            </Form.Group>
            {type === "folders" ?
              <UploadMultiFolders handleFolderChange={handleFolderChange} allowedExtensions={allowedExtensions} />
              : type === "files" &&
              <UploadMultiFiles handleFileChange={handleFileChange} />
            }
          </Modal.Body>
          <div className="text-end p-2 border-top">
            <Button
              disabled={buttonLoader || !type || selectedFiles?.length === 0}
              title={Title}
              onClick={() => { type === "files" ? uploadFilesToS3() : uploadMultipleLocalS3Folder() }}
              size="sm"
              variant="outline-primary"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Uploading...
                </div>
              ) : (
                "Upload Now"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
);
export default UploadMultiFilesFolders;
